export default {
	activate: "Activer",
	buttons: {
		create: "Nouveau type de présence",
		delete: "Supprimer",
	},
	create: "Créer un type de présence",
	createdAt: "Créé le",
	deactivate: "Désactiver",
	delete: "Supprimer le type de présence",
	deleteConfirmation: "Êtes-vous sûr de vouloir supprimer le type de présence {label} ?",
	details: {
		configuration: "Configuration",
		linkedRitualTypes: "Types de rituels associés",
		noLinkedRitualTypes: "Aucun type de rituel associé",
	},
	edit: "Modifier le type de présence",
	empty: {
		description: "Enregistrez les types de cartes de présence pour vos rituels",
		title: "Aucun type de présence trouvé",
	},
	filters: {
		status: {
			all: "Tous",
		},
	},
	form: {
		code: {
			hint: "Code court de la carte (préfixe du code complet)",
			label: "Code",
			placeholder: "Ex. : A, B, PAS, PRES",
		},
		guide: {
			hint: "Guide spirituel associé à cette présence (non obligatoire)",
			label: "Guide spirituel (optionnel)",
			placeholder: "Sélectionnez un guide",
		},
		hasQueue: {
			hint: "Les tickets sont appelés dans l'ordre (décochez pour une simple présence/inscription)",
			label: "Avec file d'attente",
		},
		label: {
			hint: "Nom descriptif du type de présence",
			label: "Nom de la carte",
			placeholder: "Ex. : Consultation Caboclo Pena Branca",
		},
		maxTickets: {
			hint: "Nombre maximum de tickets (requis pour le mode Fixe)",
			label: "Tickets maximum",
		},
		medium: {
			hint: "Médium par défaut qui assurera cette carte",
			label: "Médium par défaut",
		},
		numberingMode: {
			label: "Mode d'affichage",
		},
		tracksTime: {
			hint: "Enregistrer l'heure de début et de fin de la présence",
			label: "Suivi du temps",
		},
	},
	guide: "Guide",
	hasQueue: "Avec file d'attente",
	loading: "Chargement des détails...",
	maxTickets: "Tickets max.",
	medium: "Médium",
	messages: {
		activated: "Type de présence {label} activé avec succès",
		createError: "Erreur lors de la création du type de présence",
		created: "Type de présence {label} créé avec succès",
		deactivated: "Type de présence {label} désactivé avec succès",
		deleteError: "Erreur lors de la suppression du type de présence",
		deleted: "Type de présence {label} supprimé avec succès",
		loadError: "Erreur lors du chargement des types de présence",
		toggleError: "Erreur lors du changement de statut du type de présence",
		updateError: "Erreur lors de la mise à jour du type de présence",
		updated: "Type de présence {label} mis à jour avec succès",
	},
	numberingMode: "Mode d'affichage",
	numberingModes: {
		INCREMENTAL: "À la demande",
		PRE_DEFINED: "Fixe",
		incrementalDescription: "Tickets ajoutés un par un, à la demande",
		preDefinedDescription: "Affiche tous les tickets de 1 à N en une fois",
	},
	searchPlaceholder: "Code, nom ou guide...",
	stats: {
		active: "Actifs",
		total: "Types",
	},
	status: "Statut",
	table: {
		code: "Code",
		guide: "Guide",
		label: "Nom",
		linkedRitualTypes: "Liens",
		medium: "Médium",
		numberingMode: "Mode d'affichage",
		status: "Statut",
	},
	title: "Types de présence",
	tracksTime: "Suivi du temps",
	updatedAt: "Mis à jour le",
	validation: {
		codeMaxLength: "Le code doit avoir au maximum 4 caractères",
		codeRequired: "Le code est requis",
		labelMaxLength: "Le nom doit avoir au maximum 100 caractères",
		labelRequired: "Le nom est requis",
		maxTicketsMin: "La quantité minimale est 1",
		maxTicketsRequired: "La quantité maximale est requise pour le mode Fixe",
	},
	viewDetails: "Voir les détails",
};
